<template>
  <div class='content-wrapper'>
    <Breadcrumb :title="$t('deposit-title')" />
    <Marquee />
    <div class='row'>
      <div class='col-xl-6 col-lg-6 col-md-12'>
        <div class='card pull-up-only-shadow'>
          <div class='card-body'>
            <DepositForm />
          </div>
        </div>
      </div>
      <div class='col-xl-6 col-lg-6 col-md-12'>
        <Information />
      </div>
    </div>
    <History />
  </div>
</template>

<script>
import DepositForm from '@/components/deposit/Form.vue';
import History from '@/components/deposit/History.vue';
import Information from '@/components/deposit/Information.vue';
import Breadcrumb from '@/components/layout/Breadcrumb';
import Marquee from '@/components/markets/Marquee.vue';

export default {
  name: 'Deposit',
  components: {
    DepositForm,
    History,
    Information,
    Breadcrumb,
    Marquee
  }
};
</script>
